"use client";
import React from "react";
import { useState, useEffect, useRef } from "react";
import getSpotlight from "@/app/lib/getSpotlight";
import getPodcast from "@/app/lib/getPodcast";
import Link from "next/link";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import "./style.css";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

// import required modules
import { Pagination, Autoplay } from "swiper/modules";
// import { log } from "console";

export default function page({ blogs, spotlight, podcasts }) {
  console.log("podcasts", podcasts);
  useEffect(() => {}, []);
  return (
    <div
      style={{
        backgroundImage: "url(/Images/BG.png)",
        height: "100%",
        width: "100%",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
    >
      {/* loggedin hero section component */}
      <div className="grid grid-cols-7 place-content-between mt-5 max-ipad:grid-cols-1 max-md:m-2 justify-between">
        {/* left side cards */}
        <div className="col-span-2 max-md:col-span-1 max-ipad:order-2 max-md:flex flex-col gap-4 max-md:mt-5  w-fit">
          {/* card no : 1 */}
          {blogs && blogs.length > 0 && (
            <a href={`/ReadBlog/${blogs[0]?._id}`} className="block">
              <div className="bg-white border-[#C3C0C0] border-[0.5px] w-[300px] md:min-h-[300px] rounded-[25px] p-5 flex flex-col items-center shadow-xl md:rotate-25 z-0 max-md:flex-row max-md:w-full max-md:gap-2 max-md:min-h-40 max-md:items-start max-md:shadow-sm max-sm:flex-col">
                <img
                  src={blogs[0]?.thumbnail}
                  className="rounded-[15px] w-[300px] h-40 object-fit max-sm:w-80 m-auto block max-sm:h-33"
                />
                <div>
                  <h1 className="poppins font-semibold md:text-center text-xl text-[#011826] md:m-2">
                    {blogs[0]?.title?.length > 7
                      ? blogs[0]?.title.substring(0, 7) + "..."
                      : blogs[0]?.title}
                  </h1>
                  <p className="md:text-center text-[18px] text-[#011826] font-[300] poppins">
                    {blogs[0]?.subtitle?.length > 50
                      ? blogs[0]?.subtitle.substring(0, 50) + "..."
                      : blogs[0]?.subtitle}
                  </p>
                </div>
              </div>
            </a>
          )}
          {/* just typhography */}
          {/* <h1
            style={{ WebkitTextStroke: "2px #807ee9" }}
            className="text-[50px] text-transparent absolute font-extrabold -rotate-90 bg-clip-text text- poppins max-md:hidden"
          >
            Just
          </h1> */}
          {/* card no : 2 */}
          {blogs && blogs.length > 1 && (
            <a href={`/ReadBlog/${blogs[1]?._id}`} className="block">
              <div className="bg-white border-[#C3C0C0] border-[0.5px] w-[300px] md:min-h-[300px] rounded-[25px] p-5 flex flex-col items-center shadow-xl md:m-12 md:-rotate-25 z-0 max-md:flex-row max-md:w-full max-md:gap-2 max-md:min-h-40 max-md:items-start max-md:shadow-sm max-sm:flex-col">
                <img
                  src={blogs[1]?.thumbnail}
                  className="rounded-[15px] w-[300px] h-40 object-fit max-sm:w-80 m-auto block max-sm:h-33"
                />
                <div>
                  <h1 className="poppins font-semibold md:text-center text-xl text-[#011826] md:m-2">
                    {blogs[1]?.title?.length > 7
                      ? blogs[1]?.title.substring(0, 7) + "..."
                      : blogs[1]?.title}
                  </h1>
                  <p className="md:text-center text-[18px] text-[#011826] font-[300] poppins">
                    {blogs[1]?.subtitle?.length > 50
                      ? blogs[1]?.subtitle.substring(0, 50) + "..."
                      : blogs[1]?.subtitle}
                  </p>
                </div>
              </div>
            </a>
          )}
          {/* dropped typhography */}
          {/* <h1
            style={{ WebkitTextStroke: "2px #807ee9" }}
            className="text-[50px] text-transparent absolute left-60 font-extrabold rotate-90 bg-clip-text text- poppins max-md:hidden"
          >
            Dropped
          </h1> */}
          {/* card no : 3 */}
          {blogs && blogs.length > 2 && (
            <a href={`/ReadBlog/${blogs[2]?._id}`} className="block">
              <div className="bg-white border-[#C3C0C0] border-[0.5px] w-[300px] md:min-h-[300px] rounded-[25px] p-5 flex flex-col items-center shadow-xl md:rotate-25 z-0 max-md:flex-row max-md:w-full max-md:gap-2 max-md:min-h-40 max-md:items-start max-md:shadow-sm max-sm:flex-col">
                <img
                  src={blogs[2]?.thumbnail}
                  className="rounded-[15px] w-[300px] h-40 object-fit max-sm:w-80 m-auto block max-sm:h-33"
                />
                <div>
                  <h1 className="poppins font-semibold md:text-center text-xl text-[#011826] md:m-2">
                    {blogs[2]?.title?.length > 7
                      ? blogs[2]?.title.substring(0, 7) + "..."
                      : blogs[2]?.title}
                  </h1>
                  <p className="md:text-center text-[18px] text-[#011826] font-[300] poppins">
                    {blogs[2]?.subtitle?.length > 50
                      ? blogs[2]?.subtitle.substring(0, 50) + "..."
                      : blogs[2]?.subtitle}
                  </p>
                </div>
              </div>
            </a>
          )}
        </div>
        {/* intro side */}
        <div className="col-span-3 max-md:col-span-1 home-page-silder">
          {/* carousel */}
          <>
            {blogs && blogs?.length > 0 ? (
              <Swiper
                pagination={{
                  dynamicBullets: true,
                }}
                loop={true}
                autoplay={{ delay: 5000 }}
                modules={[Pagination, Autoplay]}
                className="mySwiper mt-10 "
              >
                <SwiperSlide className="pb-20">
                  <Link
                    className="bg-white border p-4 pb-6 block  shadow-lg md:max-w-[670px] m-auto max-ipad:m-2  "
                    href={`/ReadBlog/${blogs[0]?._id}`}
                  >
                    <div className="relative">
                      <img
                        src={blogs[0]?.thumbnail}
                        alt="cinema drip blog slider thumbnail"
                        className=" h-[468px] max-ipad:h-[270px] w-full"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-[#39353574]" />
                    </div>
                    <div className="bg-gradient-to-r from-[#00ECD4] to-[#6260FA] border p-2 flex flex-col items-center justify-center m-auto w-fit relative bottom-5">
                      <div className="bg-white w-full pb-1 px-4">
                        <h1 className="bg-gradient-to-r from-[#00ECD4] to-[#6260FA] bg-clip-text text-transparent poppins capitalize text-center leading-tight mt-2 text-[30px] font-bold">
                          Pick Of The Day
                        </h1>
                      </div>
                    </div>
                    <h1 className="bg-gradient-to-r from-[#00ECD4] to-[#6260FA] bg-clip-text text-transparent poppins capitalize text-center leading-tight text-[32px] font-semibold max-ipad:text-[20px]">
                      {blogs[0]?.category}
                    </h1>
                    <div className="bg-gradient-to-r from-[#00ECD4] to-[#6260FA] h-1 w-24 m-auto" />
                    <h3 className="text-[#011826] font-semibold poppins text-[30px] text-center mt-2 capitalize max-ipad:text-[18px]">
                      {blogs[0]?.title}
                    </h3>
                    <p className="text-[#011826] text-center mt-2 text-[16px] poppins">
                      {blogs[0]?.subtitle?.length > 159
                        ? blogs[0]?.subtitle?.substring(0, 160) + "..."
                        : blogs[0]?.subtitle}
                    </p>
                    <p className="text-center uppercase font-[300] mt-1 pb-4">
                      BY&nbsp;{blogs[0]?.author}
                    </p>
                  </Link>
                </SwiperSlide>
                <SwiperSlide className="pb-20">
                  <Link
                    href={`/ListenPodcast/${podcasts[0]?._id}`}
                    className="bg-white border p-4 pb-6  block  shadow-lg md:max-w-[670px] m-auto max-ipad:m-2 min-h-[830px] "
                  >
                    <div className="relative">
                      <img
                        src={podcasts[0]?.thumbnail}
                        alt="cinema drip blog slider thumbnail"
                        className=" h-[468px] max-ipad:h-[270px] w-full"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-[#39353574] ">
                        <div className="flex items-center gap-4 relative top-[350px] left-4 max-ipad:top-[150px]">
                          <button
                            className="bg-[#ffffff36] rounded-full radial-progress text-[#7BFF88]"
                            style={{ "--value": 70 }}
                            role="progressbar"
                          >
                            <img src="/Images/playcircle.png" className />
                          </button>
                          <img src="/Images/wave.png" className="w-26" />
                        </div>
                      </div>
                    </div>
                    <div className="bg-gradient-to-r from-[#00ECD4] to-[#6260FA] border p-2 flex flex-col items-center justify-center m-auto w-fit relative bottom-5">
                      <div className="bg-white w-full pb-1 px-4 flex items-center gap-2 ">
                        <img
                          src="/Images/micIcon.png"
                          alt=""
                          className="w-10"
                        />

                        <h1 className="bg-gradient-to-r from-[#00ECD4] to-[#6260FA] bg-clip-text text-transparent poppins capitalize text-center leading-tight mt-2 text-[30px] font-bold max-ipad:text-[25px]">
                          Top podcast
                        </h1>
                      </div>
                    </div>
                    <h3 className="text-[#011826] font-semibold poppins text-[30px] text-center mt-2 capitalize max-ipad:text-[18px]">
                      {podcasts[0]?.title}
                    </h3>
                    <p className="text-[#011826] text-center mt-2 text-[16px] poppins">
                      {podcasts[0]?.subtitle?.length > 160
                        ? podcasts[0]?.subtitle?.substring(0, 160) + "..."
                        : podcasts[0]?.subtitle}
                    </p>
                    <p className="text-center uppercase font-[300] mt-1">
                      BY&nbsp;{podcasts[0]?.host.name}
                    </p>
                  </Link>
                </SwiperSlide>
                <SwiperSlide className="pb-20">
                  <Link
                    href={`/SeeMovie/${spotlight[0]?._id}`}
                    className="bg-white border p-4 pb-6 block shadow-lg md:max-w-[670px] m-auto max-ipad:m-2 min-h-[830px] "
                  >
                    <div className="relative overflow-hidden">
                      <img
                        src={spotlight[0]?.thumbnail}
                        alt="cinema drip blog slider thumbnail"
                        className=" h-[468px] max-ipad:h-[270px] w-full"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t overflow-hidden from-black via-transparent to-[#39353574]">
                        <div className="flex items-center gap-4 relative top-[384px] left-0">
                          <button className="shadow-xl text-lg px-10 poppins py-4 bg-gradient-to-r from-[#68E7D4] via-[#55A8DD] to-[#6260FA] uppercase font-semibold text-white flex items-center gap-2 mt-5 -inset-4">
                            <img
                              src="/Images/play.png"
                              alt="play icon cinema drip"
                              width={1000}
                              height={1000}
                              className="w-8"
                            />
                            Watch
                          </button>
                        </div>
                      </div>
                    </div>
                    <h3 className="text-[#011826] font-semibold poppins text-[30px] text-center mt-2 capitalize max-ipad:text-[20px]">
                      {spotlight[0]?.title}
                    </h3>
                    <p className="text-[#011826] text-center mt-2 text-[16px] poppins">
                      {spotlight[0]?.description}
                    </p>
                    {/* <p className="text-center uppercase font-[300] mt-1">
                      BY&nbsp;{spotlight[0]?.author?.name}
                    </p> */}
                    {/* <h1 className="bg-gradient-to-r from-[#00ECD4] to-[#6260FA] bg-clip-text text-transparent poppins capitalize text-center leading-tight mt-2 text-[20px] font-semibold">
                      Take Me To the Spotlight
                    </h1> */}
                  </Link>
                </SwiperSlide>
              </Swiper>
            ) : (
              <div className="absolute right-1/2 bottom-1/2 transform translate-x-1/2 translate-y-1/2">
                <div className="p-2 bg-gradient-to-tr animate-spin from-green-500 to-blue-400 via-purple-500 rounded-full">
                  <div className="bg-white rounded-full">
                    <div className="w-24 h-24 rounded-full"></div>
                  </div>
                </div>
              </div>
            )}
          </>
        </div>
        {/* right side cards */}

        <div className="col-span-2 max-md:col-span-1 max-md:mt-5 block mr-2 m-auto ">
          <div className="col-span-2 max-md:flex flex-col  gap-5 pl-0 ">
            {/* card no : 1 */}
            {podcasts && podcasts.length > 0 && (
              <a href={`/ListenPodcast/${podcasts[0]?._id}`} className="block">
                <div className="bg-white border-[#C3C0C0] border-[0.5px] w-[300px] md:min-h-[300px] rounded-[25px] p-5 flex flex-col items-center shadow-xl md:rotate-25 z-0 max-md:flex-row max-md:w-full max-md:gap-2 max-md:min-h-40 max-md:items-start max-md:shadow-sm max-sm:flex-col">
                  <img
                    src={podcasts[0]?.thumbnail}
                    className="rounded-[15px] w-[300px] h-40 object-fit max-sm:w-80 m-auto block max-sm:h-33"
                  />
                  <div>
                    <h1 className="poppins font-semibold md:text-center text-xl text-[#011826] md:m-2">
                      {podcasts[0]?.title?.length > 7
                        ? podcasts[0]?.title.substring(0, 7) + "..."
                        : podcasts[0]?.title}
                    </h1>
                    <p className="md:text-center text-[18px] text-[#011826] font-[300] poppins">
                      {podcasts[0]?.subtitle?.length > 50
                        ? podcasts[0]?.subtitle.substring(0, 50) + "..."
                        : podcasts[0]?.subtitle}
                    </p>
                  </div>
                </div>
              </a>
            )}

            {/* Don't typhography */}
            {/* <h1
              style={{ WebkitTextStroke: "2px #807ee9" }}
              className="text-[50px] text-transparent absolute right-0 top-0 md:top-[370px] font-extrabold rotate-90 bg-clip-text text- poppins max-md:hidden"
            >
              Don't
            </h1> */}
            {/* card no : 2 */}
            {podcasts && podcasts.length > 1 && (
              <a href={`/ListenPodcast/${podcasts[1]?._id}`} className="block">
                <div className="bg-white border-[#C3C0C0] border-[0.5px] w-[300px] md:min-h-[300px] rounded-[25px] p-5 flex flex-col items-center shadow-xl md:-rotate-25 md:m-12 z-0 max-md:flex-row max-md:w-full max-md:gap-2 max-md:min-h-40 max-md:items-start max-md:shadow-sm max-sm:flex-col">
                  <img
                    src={podcasts[1]?.thumbnail}
                    className="rounded-[15px] w-[300px] h-40 object-fit max-sm:w-80 m-auto block max-sm:h-33"
                  />
                  <div>
                    <h1 className="poppins font-semibold md:text-center text-xl text-[#011826] md:m-2">
                      {podcasts[1]?.title?.length > 7
                        ? podcasts[1]?.title.substring(0, 7) + "..."
                        : podcasts[1]?.title}
                    </h1>
                    <p className="md:text-center text-[18px] text-[#011826] font-[300] poppins">
                      {podcasts[1]?.subtitle?.length > 50
                        ? podcasts[1]?.subtitle.substring(0, 50) + "..."
                        : podcasts[1]?.subtitle}
                    </p>
                  </div>
                </div>
              </a>
            )}

            {/* missout typhography */}
            {/* <h1
              style={{ WebkitTextStroke: "2px #807ee9" }}
              className="text-[50px] text-transparent absolute right-80 font-extrabold -rotate-90 bg-clip-text text- poppins max-md:hidden"
            >
              Miss out
            </h1> */}
            {/* card no : 3 */}
            {podcasts && podcasts.length > 2 && (
              <a href={`/ListenPodcast/${podcasts[2]?._id}`} className="block">
                <div className="bg-white border-[#C3C0C0] border-[0.5px] w-[300px] md:min-h-[300px] rounded-[25px] p-5 flex flex-col items-center shadow-xl md:rotate-25 z-0 max-md:flex-row max-md:w-full max-md:gap-2 max-md:min-h-40 max-md:items-start max-md:shadow-sm max-sm:flex-col">
                  <img
                    src={podcasts[2]?.thumbnail}
                    className="rounded-[15px] w-[300px] h-40 object-fit max-sm:w-80 m-auto block max-sm:h-33"
                  />
                  <div>
                    <h1 className="poppins font-semibold md:text-center text-xl text-[#011826] md:m-2">
                      {podcasts[2]?.title?.length > 7
                        ? podcasts[2]?.title.substring(0, 7) + "..."
                        : podcasts[2]?.title}
                    </h1>
                    <p className="md:text-center text-[18px] text-[#011826] font-[300] poppins">
                      {podcasts[2]?.subtitle?.length > 50
                        ? podcasts[2]?.subtitle.substring(0, 50) + "..."
                        : podcasts[2]?.subtitle}
                    </p>
                  </div>
                </div>
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

// "use client";
// import React from "react";
// import { useState, useEffect, useRef } from "react";
// import getSpotlight from "@/app/lib/getSpotlight";
// import getPodcast from "@/app/lib/getPodcast";
// import Link from "next/link";
// // Import Swiper React components
// import { Swiper, SwiperSlide } from "swiper/react";
// import "./style.css";

// // Import Swiper styles
// import "swiper/css";
// import "swiper/css/pagination";

// // import required modules
// import { Pagination, Autoplay } from "swiper/modules";

// export default function page({ blogs, spotlight, podcasts }) {
//   useEffect(() => {}, []);
//   const cardData = [
//     {
//       title: "TV Series",
//       description: "X-Men 97 exclusive look reveals legacy costumes, the James",
//       link: "/viewAllPodcast?genres=tv%20awards",
//       image: "/Images/ab (1).webp",
//     },
//     {
//       title: "Web Series",
//       description:
//         "Marvel Web Universe reveals multiverse storylines in new teaser",
//       link: "/viewAllPodcast?genres=web%20series",
//       image: "/Images/ab (2).jpg",
//     },
//     {
//       title: "Reality Show",
//       description:
//         "Big Brother season 23 brings shocking eliminations and twists",
//       link: "/viewAllPodcast?genres=reality%20show",
//       image: "/Images/ab (3).jpg",
//     },
//     {
//       title: "Drama",
//       description:
//         "Emotional rollercoaster in Netflix’s latest family drama series",
//       link: "/viewAllPodcast?genres=drama",
//       image: "/Images/ab (4).jpg",
//     },
//     {
//       title: "Documentary",
//       description: "Explore secrets of ancient civilizations in new docuseries",
//       link: "/viewAllPodcast?genres=documentary",
//       image: "/Images/ab (5).jpg",
//     },
//     {
//       title: "Comedy",
//       description:
//         "Laugh out loud with the newest lineup of hilarious comedy shows",
//       link: "/viewAllPodcast?genres=comedy",
//       image: "/Images/image.jpg",
//     },
//   ];
//   return (
//     <div
//       style={{
//         backgroundImage: "url(/Images/BG.png)",
//         height: "100%",
//         width: "100%",
//         backgroundRepeat: "no-repeat",
//         backgroundSize: "cover",
//       }}
//     >
//       {/* loggedin hero section component */}
//       <div className="grid grid-cols-7 place-content-between mt-5 max-ipad:grid-cols-1 max-md:m-2 justify-between">
//         {/* left side cards */}
//         <div className="col-span-2 max-md:col-span-1 max-ipad:order-2 max-md:flex flex-col gap-4 ml-12 max-md:mt-5 w-fit">
//           {cardData.slice(0, 3).map((card, idx) => (
//             <a href={card.link} className="block" key={idx}>
//               <div className="bg-white border-[#C3C0C0] border-[0.5px] w-[300px] md:min-h-[300px] rounded-[25px] p-5 flex flex-col items-center shadow-xl z-0 md:rotate-25 md:m-4 max-md:flex-row max-md:w-full max-md:gap-2 max-md:min-h-40 max-md:items-start max-md:shadow-sm max-sm:flex-col">
//                 <img
//                   src={card.image}
//                   alt={card.title}
//                   className="rounded-[15px] w-[300px] h-40 object-cover max-sm:w-80 m-auto block"
//                 />
//                 <div>
//                   <h1 className="poppins font-semibold md:text-center text-xl text-[#011826] md:m-2">
//                     {card.title}
//                   </h1>
//                   <p className="md:text-center text-[18px] text-[#011826] font-[300] poppins">
//                     {card.description}
//                   </p>
//                 </div>
//               </div>
//             </a>
//           ))}
//         </div>

//         {/* intro side */}
//         <div className="col-span-3 max-md:col-span-1 home-page-silder">
//           {/* carousel */}
//           <>
//             {blogs && blogs?.length > 0 ? (
//               <Swiper
//                 pagination={{
//                   dynamicBullets: true,
//                 }}
//                 loop={true}
//                 autoplay={{ delay: 5000 }}
//                 modules={[Pagination, Autoplay]}
//                 className="mySwiper mt-10 "
//               >
//                 <SwiperSlide className="pb-20">
//                   <Link
//                     className="bg-white border p-4 pb-6 block  shadow-lg md:max-w-[670px] m-auto max-ipad:m-2  "
//                     href={`/ReadBlog/${blogs[0]?._id}`}
//                   >
//                     <div className="relative">
//                       <img
//                         src={blogs[0]?.thumbnail}
//                         alt="cinema drip blog slider thumbnail"
//                         className=" h-[468px] max-ipad:h-[270px] w-full"
//                       />
//                       <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-[#39353574]" />
//                     </div>
//                     <div className="bg-gradient-to-r from-[#00ECD4] to-[#6260FA] border p-2 flex flex-col items-center justify-center m-auto w-fit relative bottom-5">
//                       <div className="bg-white w-full pb-1 px-4">
//                         <h1 className="bg-gradient-to-r from-[#00ECD4] to-[#6260FA] bg-clip-text text-transparent poppins capitalize text-center leading-tight mt-2 text-[30px] font-bold">
//                           Pick Of The Day
//                         </h1>
//                       </div>
//                     </div>
//                     <h1 className="bg-gradient-to-r from-[#00ECD4] to-[#6260FA] bg-clip-text text-transparent poppins capitalize text-center leading-tight text-[32px] font-semibold max-ipad:text-[20px]">
//                       {blogs[0]?.category}
//                     </h1>
//                     <div className="bg-gradient-to-r from-[#00ECD4] to-[#6260FA] h-1 w-24 m-auto" />
//                     <h3 className="text-[#011826] font-semibold poppins text-[30px] text-center mt-2 capitalize max-ipad:text-[18px]">
//                       {blogs[0]?.title}
//                     </h3>
//                     <p className="text-[#011826] text-center mt-2 text-[16px] poppins">
//                       {blogs[0]?.subtitle?.length > 159
//                         ? blogs[0]?.subtitle?.substring(0, 160) + "..."
//                         : blogs[0]?.subtitle}
//                     </p>
//                     <p className="text-center uppercase font-[300] mt-1 pb-4">
//                       BY&nbsp;{blogs[0]?.author}
//                     </p>
//                   </Link>
//                 </SwiperSlide>
//                 <SwiperSlide className="pb-20">
//                   <Link
//                     href={`/ListenPodcast/${podcasts[0]?._id}`}
//                     className="bg-white border p-4 pb-6  block  shadow-lg md:max-w-[670px] m-auto max-ipad:m-2 min-h-[830px] "
//                   >
//                     <div className="relative">
//                       <img
//                         src={podcasts[0]?.thumbnail}
//                         alt="cinema drip blog slider thumbnail"
//                         className=" h-[468px] max-ipad:h-[270px] w-full"
//                       />
//                       <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-[#39353574] ">
//                         <div className="flex items-center gap-4 relative top-[350px] left-4 max-ipad:top-[150px]">
//                           <button
//                             className="bg-[#ffffff36] rounded-full radial-progress text-[#7BFF88]"
//                             style={{ "--value": 70 }}
//                             role="progressbar"
//                           >
//                             <img src="/Images/playcircle.png" className />
//                           </button>
//                           <img src="/Images/wave.png" className="w-26" />
//                         </div>
//                       </div>
//                     </div>
//                     <div className="bg-gradient-to-r from-[#00ECD4] to-[#6260FA] border p-2 flex flex-col items-center justify-center m-auto w-fit relative bottom-5">
//                       <div className="bg-white w-full pb-1 px-4 flex items-center gap-2 ">
//                         <img
//                           src="/Images/micIcon.png"
//                           alt=""
//                           className="w-10"
//                         />

//                         <h1 className="bg-gradient-to-r from-[#00ECD4] to-[#6260FA] bg-clip-text text-transparent poppins capitalize text-center leading-tight mt-2 text-[30px] font-bold max-ipad:text-[25px]">
//                           Top podcast
//                         </h1>
//                       </div>
//                     </div>
//                     <h3 className="text-[#011826] font-semibold poppins text-[30px] text-center mt-2 capitalize max-ipad:text-[18px]">
//                       {podcasts[0]?.title}
//                     </h3>
//                     <p className="text-[#011826] text-center mt-2 text-[16px] poppins">
//                       {podcasts[0]?.subtitle?.length > 160
//                         ? podcasts[0]?.subtitle?.substring(0, 160) + "..."
//                         : podcasts[0]?.subtitle}
//                     </p>
//                     <p className="text-center uppercase font-[300] mt-1">
//                       BY&nbsp;{podcasts?.host?.name}
//                     </p>
//                   </Link>
//                 </SwiperSlide>
//                 <SwiperSlide className="pb-20">
//                   <Link
//                     href={`/SeeMovie/${spotlight[0]?._id}`}
//                     className="bg-white border p-4 pb-6 block shadow-lg md:max-w-[670px] m-auto max-ipad:m-2 min-h-[830px] "
//                   >
//                     <div className="relative overflow-hidden">
//                       <img
//                         src={spotlight[0]?.thumbnail}
//                         alt="cinema drip blog slider thumbnail"
//                         className=" h-[468px] max-ipad:h-[270px] w-full"
//                       />
//                       <div className="absolute inset-0 bg-gradient-to-t overflow-hidden from-black via-transparent to-[#39353574]">
//                         <div className="flex items-center gap-4 relative top-[384px] left-0">
//                           <button className="shadow-xl text-lg px-10 poppins py-4 bg-gradient-to-r from-[#68E7D4] via-[#55A8DD] to-[#6260FA] uppercase font-semibold text-white flex items-center gap-2 mt-5 -inset-4">
//                             <img
//                               src="/Images/play.png"
//                               alt="play icon cinema drip"
//                               width={1000}
//                               height={1000}
//                               className="w-8"
//                             />
//                             Watch
//                           </button>
//                         </div>
//                       </div>
//                     </div>
//                     <h3 className="text-[#011826] font-semibold poppins text-[30px] text-center mt-2 capitalize max-ipad:text-[20px]">
//                       {spotlight[0]?.title}
//                     </h3>
//                     <p className="text-[#011826] text-center mt-2 text-[16px] poppins">
//                       {spotlight[0]?.description}
//                     </p>
//                     <p className="text-center uppercase font-[300] mt-1">
//                       BY&nbsp;{spotlight[0]?.author?.name}
//                     </p>
//                     <h1 className="bg-gradient-to-r from-[#00ECD4] to-[#6260FA] bg-clip-text text-transparent poppins capitalize text-center leading-tight mt-2 text-[20px] font-semibold">
//                       Take Me To the Spotlight
//                     </h1>
//                   </Link>
//                 </SwiperSlide>
//               </Swiper>
//             ) : (
//               <div className="absolute right-1/2 bottom-1/2 transform translate-x-1/2 translate-y-1/2">
//                 <div className="p-2 bg-gradient-to-tr animate-spin from-green-500 to-blue-400 via-purple-500 rounded-full">
//                   <div className="bg-white rounded-full">
//                     <div className="w-24 h-24 rounded-full"></div>
//                   </div>
//                 </div>
//               </div>
//             )}
//           </>
//         </div>
//         {/* right side cards */}
//         <div className="col-span-2 max-md:col-span-1 max-md:mt-5 block mr-12 m-auto">
//           {cardData.slice(3, 6).map((card, idx) => (
//             <a href="{card.link}" className="block" key={idx}>
//               <div className="bg-white border-[#C3C0C0] border-[0.5px] w-[300px] md:min-h-[300px] rounded-[25px] p-5 flex flex-col items-center shadow-xl z-0 md:rotate-25 md:m-4 max-md:flex-row max-md:w-full max-md:gap-2 max-md:min-h-40 max-md:items-start max-md:shadow-sm max-sm:flex-col">
//                 <img
//                   src={card.image}
//                   alt={card.title}
//                   className="rounded-[15px] w-[300px] h-40 object-cover max-sm:w-80 m-auto block"
//                 />
//                 <div>
//                   <h1 className="poppins font-semibold md:text-center text-xl text-[#011826] md:m-2">
//                     {card.title}
//                   </h1>
//                   <p className="md:text-center text-[18px] text-[#011826] font-[300] poppins">
//                     {card.description}
//                   </p>
//                 </div>
//               </div>
//             </a>
//           ))}
//           {/* <h1
//             style={{ WebkitTextStroke: "2px #807ee9" }}
//             className="text-[50px] text-transparent absolute right-0 top-0 md:top-[370px] font-extrabold rotate-90 bg-clip-text poppins max-md:hidden"
//           >
//             Don't
//           </h1> */}
//         </div>
//       </div>
//     </div>
//   );
// }
